export default {
    project_name: "Universidade Newell",
	company_agency: 'Profession',
}